import { render, staticRenderFns } from "./DoughnutReviewInHouse.vue?vue&type=template&id=19bec61f&scoped=true&"
import script from "./DoughnutReviewInHouse.vue?vue&type=script&lang=js&"
export * from "./DoughnutReviewInHouse.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutReviewInHouse.vue?vue&type=style&index=0&id=19bec61f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bec61f",
  null
  
)

export default component.exports